/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_MysteryInputs */

const en_onboarding_genre_mystery = /** @type {(inputs: Onboarding_Genre_MysteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mystery`)
};

const es_onboarding_genre_mystery = /** @type {(inputs: Onboarding_Genre_MysteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misterio`)
};

/**
* | output |
* | --- |
* | "Mystery" |
*
* @param {Onboarding_Genre_MysteryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_mystery = /** @type {((inputs?: Onboarding_Genre_MysteryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_MysteryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_mystery(inputs)
	return en_onboarding_genre_mystery(inputs)
});